var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import get from "lodash/get";
import set from "lodash/set";
import merge from "lodash/merge";
import i18next from 'i18next';
import memoize from "lodash/memoize";
import uniq from "lodash/uniq";
import assign from "lodash/assign";
import keys from "lodash/keys";
import { normalizeDate } from "../../helpers/date";
import { VALIDATION_MESSAGE, VALIDATION_MESSAGE_LIST, VALIDATION_MESSAGE_HEADER } from "../../classConstants";
export var BOOK_NOW_EVENT = "ws-book-now-event";
export var ADMIN_FORM_TOGGLES = [
    "is_validation_unstrict",
    "disable_customer_personal_data",
    "not_send_bills",
    "without_billing",
    "not_send_bookings",
    "draft_bills",
    "draft_bookings",
    "waitlist_bookings"
];
export var ENABLED_ADMIN_FORM_TOGGLES_MAP = {};
export var normalizeDefaultFormData = function (formData) {
    var consentAgreementPath = "form_data.consent_agreement";
    var formGroupPath = "form_data.form_group";
    var formFieldPath = "form_data.form_field";
    var consentAgreement = get(formData, consentAgreementPath);
    var formGroup = get(formData, formGroupPath);
    var formField = get(formData, formFieldPath);
    if (Array.isArray(consentAgreement)) {
        set(formData, consentAgreementPath, merge({}, consentAgreement));
    }
    if (Array.isArray(formGroup)) {
        set(formData, formGroupPath, merge({}, formGroup));
    }
    if (formField === null || formField === void 0 ? void 0 : formField.extra_columns) {
        set(formField, 'extra_columns', formField === null || formField === void 0 ? void 0 : formField.extra_columns.map(function (value) { return (__assign({}, value)); }));
    }
    return formData;
};
export var normalizeDefaultBillReceiverIndex = function (formData) {
    var billReceiverIndex = get(formData, "booking_data.bill_receiver_index");
    if (typeof billReceiverIndex === "number")
        set(formData, 'booking_data.bill_receiver_index', "" + billReceiverIndex);
    return formData;
};
export var onCategoryChange = function (index) {
    return function (state) {
        var _a;
        return ({
            categoryNames: (_a = state.categoryNames) === null || _a === void 0 ? void 0 : _a.slice(0, index + 1),
        });
    };
};
export var getParticipantTitle = function (translateKey, participant) {
    var props = merge({ title: "", first_name: "", last_name: "", company: "", salutation: "" }, participant);
    return (i18next.t(translateKey, props) || "").trim();
};
var participantConditions = {
    or: [
        { and: ["company"] },
        { and: ["first_name", "last_name", "salutation_id"], }
    ]
};
var concludeOrEvaluate = function (data, condition) {
    return typeof condition === "string" ? !!get(data, condition) : concludeConditions(data, condition);
};
var concludeConditions = function (data, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.and, and = _c === void 0 ? [] : _c, _d = _b.or, or = _d === void 0 ? [] : _d;
    return (or.length === 0 && and.length === 0)
        || (or.length > 0 && or.some(concludeOrEvaluate.bind(null, data)))
        || (and.length > 0 && and.every(concludeOrEvaluate.bind(null, data)));
};
export var isParticipantValid = function (participant) { return concludeConditions(participant, participantConditions); };
export var getParticipantsAsSelectOptions = function (participants, bookersCount, options) {
    if (options === void 0) { options = {}; }
    var otherParticipants = get(options, "otherSelectedParticipantIndexes", []).map(function (index) { return +index; });
    var salutations = get(options, "salutations", {});
    var allParticipants = participants
        .filter(Boolean)
        .map(function (x, index) { return get(options, "selection") !== "" + index && get(options, "exclude", []).includes("" + index) ? null : x; })
        .map(function (participant, i) {
        var _a;
        var index = get(participant, "index", i);
        var hasParticipantData = isParticipantValid(participant);
        var addToOptions = (hasParticipantData || get(options, "selection") === "" + index);
        if (!participant || !addToOptions || otherParticipants.includes(+index))
            return null;
        var label = !hasParticipantData ? "" : participant.label || getParticipantTitle("bookcart.participant_name", __assign(__assign({}, participant), { salutation: (_a = salutations[participant.salutation_id]) === null || _a === void 0 ? void 0 : _a.label })) || "";
        if (!label.trim())
            label = i18next.t("bookcart.participant_header", { index: i + 1 });
        return {
            value: "" + index,
            label: label,
        };
    }).filter(Boolean);
    if (get(options, "createNewParticipant", false)) {
        var index = get(options, "index");
        var existingIndices = allParticipants.map(function (_a) {
            var value = _a.value;
            return +value;
        });
        var allIndices = __spreadArray(__spreadArray([], otherParticipants), existingIndices);
        var defaultIndex = get(options, "defaultIndices", [])[index];
        if (defaultIndex && existingIndices.includes(+defaultIndex)) {
            return allParticipants;
        }
        if (!!participants[index])
            allIndices.push(index);
        var value = get(options, "defaultIndices", [])[index] || getParticipantIndex(allIndices, -1) + "";
        allParticipants.push({ value: value, label: i18next.t("bookcart.add_new_participant") });
    }
    return allParticipants;
};
export var getFieldPaths = function (arr, mergedProps, parentIndex) {
    if (mergedProps === void 0) { mergedProps = { invalidStepIndex: null }; }
    if (parentIndex === void 0) { parentIndex = null; }
    return arr.filter(Boolean).reduce(function (allNames, field, index) {
        var stepIndex = parentIndex === null ? index : parentIndex;
        if ((field === null || field === void 0 ? void 0 : field.error_message) && mergedProps.invalidStepIndex === null) {
            mergedProps.invalidStepIndex = stepIndex;
        }
        if (field.fields) {
            return allNames.concat(getFieldPaths(field.fields, mergedProps, stepIndex));
        }
        if (field.name)
            allNames.push(field.name);
        return allNames;
    }, []);
};
export var getFilteredData = function (fieldPaths, form, switchablePathConstant) {
    if (switchablePathConstant === void 0) { switchablePathConstant = ""; }
    return fieldPaths.reduce(function (filteredValues, path) {
        if (switchablePathConstant && path.startsWith(switchablePathConstant))
            return filteredValues;
        var actualPath = path.match(/(\.date)$/) ? path.replace(/(\.date)$/, "") : path;
        var value = get(form, actualPath);
        if (value || ![null, undefined].includes(value)) {
            set(filteredValues, actualPath, value);
        }
        return filteredValues;
    }, {
        form_data: {
            consent_agreement: {},
            form_group: {},
            form_field: {}
        }
    });
};
export var getParticipantIndex = function (indices, index, startIndex) {
    if (indices === void 0) { indices = []; }
    if (startIndex === void 0) { startIndex = 0; }
    var uniqIndices = uniq(indices);
    return memoize(function (indicesString, index) {
        var participantIndex = get(uniqIndices, index);
        if ([undefined, null].includes(participantIndex)) {
            var _loop_1 = function (counter) {
                if (!indices.some(function (i) { return counter === +i; })) {
                    indices.push("" + counter);
                    return { value: "" + counter };
                }
            };
            for (var counter = startIndex;; counter++) {
                var state_1 = _loop_1(counter);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        return "" + participantIndex;
    }, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return args.join("_");
    })(JSON.stringify(uniqIndices) + index, index);
};
export var normalizeBookingSlot = function (bookingSlot) {
    var _a, _b;
    if (!bookingSlot)
        return bookingSlot;
    return assign(bookingSlot, {
        from: normalizeDate(((_a = bookingSlot.from) === null || _a === void 0 ? void 0 : _a.date) || bookingSlot.from),
        to: normalizeDate(((_b = bookingSlot.to) === null || _b === void 0 ? void 0 : _b.date) || bookingSlot.to)
    });
};
export var getBookingSlot = function (form) {
    return get(form, "booking_data.booking_slot");
};
export var CART_ITEMS_PATH = "booking_data.cart_items";
export var getTimespanId = function (form) {
    return get(form, TIMESPAN_ID_PATH);
};
export var getPriceId = function (form) {
    return get(form, PRICE_ID_PATH);
};
export var getBookersCount = function (form) {
    return get(form, BOOKER_COUNT_PATH);
};
export var getExtraPrices = function (form) {
    return (get(form, CART_ITEMS_PATH) || []).slice(1);
};
export var getPersonalDataIndex = function (form) {
    return get(form, PERSONAL_DATA_INDEX_PATH);
};
export var getCartItemPath = function (index) {
    return CART_ITEMS_PATH + ("." + index);
};
export var getCartItemPriceIdPath = function (index) {
    return CART_ITEMS_PATH + ("." + index + ".position.price_id");
};
export var getCartItemQuantityPath = function (index) {
    return CART_ITEMS_PATH + ("." + index + ".position.quantity");
};
export var getCartItemTimespanIdPath = function (index) {
    return CART_ITEMS_PATH + ("." + index + ".booking.course_timespan_id");
};
export var getCartItemPersonalDataPath = function (index) {
    return CART_ITEMS_PATH + ("." + index + ".booking.personal_data_index");
};
export var getComments = function (form) {
    return (get(form, COMMENTS_PATH, ""));
};
export var ROOT_CART_ITEM_INDEX = 0;
export var TIMESPAN_ID_PATH = getCartItemTimespanIdPath(ROOT_CART_ITEM_INDEX);
export var PRICE_ID_PATH = getCartItemPriceIdPath(ROOT_CART_ITEM_INDEX);
export var BOOKER_COUNT_PATH = getCartItemQuantityPath(ROOT_CART_ITEM_INDEX);
export var PERSONAL_DATA_INDEX_PATH = getCartItemPersonalDataPath(ROOT_CART_ITEM_INDEX);
export var COMMENTS_PATH = "form_data.form_field.course_participants[" + ROOT_CART_ITEM_INDEX + "].comment";
export var getReferenceFieldPath = function (formGroupId) { return "field_ref.reference_" + formGroupId; };
export var ADMIN_SETTINGS_KEY = "admin_config_toggles";
export var getAdminSettings = function (form) {
    return get(form, ADMIN_SETTINGS_KEY);
};
export var isValidationDisabled = function (form) {
    return get(getAdminSettings(form), "is_validation_unstrict", false);
};
export var hasAllowAllEvents = function (form) {
    return get(getAdminSettings(form), "allow_all_events", false);
};
export var hasWaitlistBookings = function (form) {
    return get(getAdminSettings(form), "waitlist_bookings", false);
};
export var getSearchAndSelectName = function (name) { return "additional_props.search_n_select." + name.replace(/[\[\]\.]/g, "_"); };
export var deriveFieldMessage = function (form, validationErrors, fieldName) {
    var billReceiverIndex = form.billRecipientIndex;
    var errorFieldName = fieldName.replace("form_data.", "");
    var billErrorFieldName = errorFieldName.replace(/personal_data\.\d+/, "bill." + billReceiverIndex);
    return (validationErrors[billErrorFieldName] || validationErrors[errorFieldName] || [])[0];
};
export var deriveValidationMessages = function (formManager, validationErrors, fieldPaths, steps) {
    var _a, _b;
    if (!formManager)
        return [];
    if (!validationErrors)
        return [];
    var form = formManager.toRequestBody(fieldPaths);
    var participantPath = form.toWaitList ? "waitlist" : "personal_data";
    var participants = get(form, "form_data.form_field." + participantPath);
    var billReceiverIndex = "" + get(form, "booking_data.bill_receiver_index");
    var map = {};
    var personalDataIndices = ((_b = (_a = form === null || form === void 0 ? void 0 : form.booking_data) === null || _a === void 0 ? void 0 : _a.cart_items) === null || _b === void 0 ? void 0 : _b.reduce(function (cartIndices, cartItem, i, self) {
        var parentPriceId = get(cartItem, "position.parent_price_id", null);
        if (parentPriceId !== null) {
            return cartIndices;
        }
        if (parentPriceId === null) {
            var priceId = get(cartItem, "position.price_id") && "priceId_" + get(cartItem, "position.price_id");
            var timespanId = get(cartItem, "booking.course_timespan_id") && "timespanId_" + get(cartItem, "booking.course_timespan_id");
            var id = priceId || timespanId;
            if (!map[id]) {
                map[id] = true;
                cartIndices.push({ messages: [], indices: [], billerStep: false, index: cartIndices.length });
            }
        }
        cartIndices.slice(-1)[0].indices.push("" + get(cartItem, "booking.personal_data_index"));
        return cartIndices;
    }, [])) || [];
    personalDataIndices.push({ messages: [], indices: [billReceiverIndex], billerStep: true });
    var cartIndices = {};
    var extractPositionRegex = new RegExp("form_field\\." + participantPath + "\\.(?<position>\\d+)\\.");
    keys(validationErrors).forEach(function (key) {
        var _a, _b;
        var position = ((_b = (_a = key.match(new RegExp(extractPositionRegex))) === null || _a === void 0 ? void 0 : _a.groups) === null || _b === void 0 ? void 0 : _b.position) || "";
        if (!position) {
            return;
        }
        if (cartIndices[position] === undefined) {
            for (var cartIndex_1 = 0; cartIndex_1 < personalDataIndices.length; cartIndex_1++) {
                var dataIndices_1 = personalDataIndices[cartIndex_1];
                if (dataIndices_1.indices.includes("" + position)) {
                    cartIndices[position] = cartIndex_1;
                    break;
                }
            }
        }
        if (cartIndices[position] === undefined) {
            return;
        }
        var cartIndex = cartIndices[position];
        var dataIndices = personalDataIndices[cartIndex];
        var isBillerStep = dataIndices.billerStep;
        var participantName = (billReceiverIndex === position) ? "bookcart.biller_participant_name" : "bookcart.participant_name";
        var participantHeader = (billReceiverIndex === position) ? "bookcart.biller_participant_header" : "bookcart.participant_header";
        var participant = (participants === null || participants === void 0 ? void 0 : participants[position]) || {};
        var label = (isParticipantValid(participant) && getParticipantTitle(participantName, participant)) || i18next.t(participantHeader, { index: +position + 1 });
        var prefix = isBillerStep ? "" : label + ": ";
        dataIndices.messages.push("<li class=\"" + VALIDATION_MESSAGE + "\">" + prefix + " " + deriveFieldMessage(form, validationErrors, key) + "</li>");
    }, []);
    var message = personalDataIndices.reduce(function (message, _a, index) {
        var _b;
        var messages = _a.messages, billerStep = _a.billerStep;
        if (messages.length === 0)
            return message;
        var header = billerStep ? i18next.t("bookcart.bill_recipient") : (_b = steps[index]) === null || _b === void 0 ? void 0 : _b.title;
        return message + ("<h4 class=\"" + VALIDATION_MESSAGE_HEADER + "\">" + header + "</h4><ul class=\"" + VALIDATION_MESSAGE_LIST + "\"> " + messages.join("\n") + " </ul>");
    }, "");
    return message.length <= 0 ? [] : [{
            level: "danger",
            message: message
        }];
};
export var getFirstTimespanId = function (state, formName) {
    try {
        var form = get(state, "formReducer.forms." + formName, {}), timespanIds = get(form, "booking_data.cart_items", [])
            .map(function (cartItem) { return get(cartItem, "booking.course_timespan_id", null); })
            .filter(Boolean)
            .slice(0, 1);
        return timespanIds.map(function (x) { return String(x); })[0] || "";
    }
    catch (_a) {
        return [];
    }
};
